import { Box, Text } from 'theme-ui';
import clampBuilder from '~/utils/clamp-builder';

const ContactCard = ({ card, action, widestRef, width }) => {
  const handleClick = (e) => {
    const event = new CustomEvent('custom-event', {
      bubbles: true,
      detail: { category: 'ux_click', action: 'support_footer', label: action ? 'live_chat' : 'contact_us' },
    });
    e.target.dispatchEvent(event);
    if (action) action(e);
  };
  return (
    <Box
      ref={widestRef ?? null}
      as="article"
      sx={{
        display: 'flex',
        alignItems: 'center',
        background: 'white',
        borderRadius: '23px 0px 72px',
        padding: ['5rem 4rem', null, '4rem 10.5rem 4rem 4.5rem'],
      }}
    >
      {card.icon && <img src={card.icon?.file.url} alt={card.icon?.description}></img>}
      <Box sx={{ marginLeft: ['4.2rem', null, '4.5rem'] }}>
        <Text as="h4" variant="text.caps" sx={{ margin: 0 }}>
          {card.name}
        </Text>
        {card.body && (
          <Box
            sx={{
              fontSize: ['1.6rem'],
              a: { textDecoration: 'underline' },
              span: {
                whiteSpace: 'nowrap',
                fontSize: ['clamp(8px, 3vw, 13px)', 'inherit', clampBuilder(1281, 1440, 1.3, 1.7)],
              },
              width: ['100%', '40rem'],
            }}
            dangerouslySetInnerHTML={{
              __html: card.body.childrenMarkdownRemark[0].html,
            }}
          />
        )}
        <a sx={{ textDecoration: 'underline' }} href={card.linkSlug ?? '#'} onClick={handleClick}>
          {card.link}
        </a>
      </Box>
    </Box>
  );
};

export default ContactCard;
